import clsx from 'clsx'
import React from 'react'
import useStyles from './styles'

interface Props {
  language: string
  isSmall?: boolean
}

const Flag: React.FC<Props> = ({ language, isSmall }) => {
  const classes = useStyles()
  const flagUrl = `https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/flags/4x3/${language}.svg`
  const flagStyle: React.CSSProperties = { backgroundImage: `url(${flagUrl})` }

  return (
    <div className={clsx(classes.root, { [classes.small]: isSmall })}>
      <div>{language}</div>
      <span role="img" aria-label={language} className="flagIcon" style={flagStyle} />
    </div>
  )
}

export default Flag
